var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"wrapper",staticClass:"db-marquee-container dashboard-summary-div",style:(_vm.setAlertBg(_vm.alertType))},[_c('span',{ref:"message",staticClass:"db-marquee-text"},[_vm._v(_vm._s(_vm.alertMessage))])])
}
var staticRenderFns = []

export { render, staticRenderFns }